/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */
window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js').default;
require('bootstrap');
require('select2');
window.Hammer = require('hammerjs');
require('leaflet');

window.flatpickr = require('flatpickr');
const flatpickrLocalization = require("flatpickr/dist/l10n/es.js").default.es;
window.flatpickr.localize(flatpickrLocalization);
window.flatpickr.setDefaults({
    locale: {
        firstDayOfWeek: 0
    },
    allowInput: true,
    wrap: true,
    // disableMobile: true
});
window.fancybox = require('@fancyapps/fancybox');
window.marquee = require('jquery.marquee');
